var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.classList }, [
    _c(
      "div",
      [
        _vm.icon
          ? _c("base-icon", {
              staticClass: "_tc--accent",
              attrs: { name: _vm.icon, "icon-namespace": _vm.iconNamespace },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.imageUrl
          ? _c("base-image", { attrs: { src: _vm.imageUrl, height: "14" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.text ? _c("span", [_vm._v(_vm._s(_vm.text))]) : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "_tc--accent", attrs: { "data-qa": "learn-more" } },
      [_vm._v(_vm._s(_vm.Resources.ProjectHome.ProjectSummaryLearnMoreButton))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }